import { render, staticRenderFns } from "./Criterion.vue?vue&type=template&id=a26f10e4&scoped=true&"
import script from "./Criterion.vue?vue&type=script&lang=ts&"
export * from "./Criterion.vue?vue&type=script&lang=ts&"
import style0 from "./Criterion.vue?vue&type=style&index=0&id=a26f10e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26f10e4",
  null
  
)

export default component.exports